<template>
    <div v-if="!appData.enableAuditLogOption && !appData.enableAuditLogTrial">
        <div class="object-titlebox">
            <div class="object-titlebox-left" v-t="'message.title_setting_permit_ip_address'"></div>
        </div>
        <div class="object-inner-table">
            <table width=100%>
                <td v-if="appData.basicContract.planType == Const.LICENSE_PLAN_SEPARATE" width=50% class="object-item" v-t="'message.info_need_purchase_option'">
                </td>
                <td v-else width=50% class="object-item" v-t="'message.info_need_purchase_enterprise_plan'">
                </td>
            </table>
        </div>
    </div>
    <div v-else>
        <div class="object-titlebox">
            <div class="title-box-left">
                <span v-t="'message.title_setting_permit_ip_address'"></span>
                <div class="title-box-right">
                    <button class="transparent" type="button" v-on:click="showEditPermitIpAddress=true"><img src="../../../../assets/edit.svg"/><span class="normal-command-text" v-t="'message.common_action_edit'"></span></button>
                </div>
            </div>
        </div>
        <div v-if="enablePermitIpOption">
            <table width="100%">
                <tr class="object-titlebox">
                    <td class="header-value" width="200px" style="padding-left:20px" v-t="'message.item_ip_address'"></td>
                    <td class="header-value" style="padding-left:15px" v-t="'message.item_comment'"></td>
                </tr>
                <tr v-for="permitIp in permitIpAddressList" class="ip-address-record">
                    <td class="object-value" width="200px" style="padding-left:20px">{{ permitIp.definedIp }}</td>
                    <td class="object-value">{{ permitIp.description }}</td>
                </tr>
            </table>
        </div>
        <div v-else>
            <div class="object-value" colspan="2" style="padding-left:20px" v-t="'message.info_all_ip_address_has_permitted'">。</div>
        </div>
        <EditPermitIpAddress v-if="showEditPermitIpAddress" ref="editPermitIpAddress" :enablePermitIpOption="enablePermitIpOption" :permitIpAddressList="permitIpAddressList" @save="modifyPermitIpAddressList" @cancel="showEditPermitIpAddress=false"></EditPermitIpAddress>
    </div>
</template>

<script>
import server from "../../../ServerApi.js";
import commonUtil from '../../../commonutil.js';
import constants from '../../../constants.js';
import EditPermitIpAddress from "@/components/pc/setting/permitip/PermitIpSettingEdit.vue";

export default {
    data() {
        return {
            permitIpAddressList: [],
            showEditPermitIpAddress: false,
            enablePermitIpOption: false,
            Const: {
                LICENSE_PLAN_SEPARATE: constants.LICENSE_PLAN_SEPARATE
            }
        };
    },
    methods: {
        getPermitIpAddressList() {
            let self = this;
            server.post('/getpermitipaddresslist')
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            self.permitIpAddressList = res.data.ipAddressList;
                            for (let permitIpAddress of self.permitIpAddressList) {
                                // set numeric IP address for sorting key
                                permitIpAddress.fromIp = commonUtil.changeAddressToNumeric(permitIpAddress.definedIp);
                            }
                            self.permitIpAddressList.sort(function(a, b) {
                                if (a.fromIp > b.fromIp) {
                                    return 1;
                                } else {
                                    return -1;
                                }
                            })
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getPermitIpAddressList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "getPermitIpAddressList", error);
                });
        },
        modifyPermitIpAddressList(inputParam) {
            let self = this;
            if (inputParam.requestType == 1) {
                if (inputParam.addIpAddressList.length == 0 && inputParam.modifyIpAddressList.length == 0 && inputParam.removeIpAddressList.length == 0) {
                    commonUtil.notifyMessage(this,"Info",commonUtil.getMessageText(self.$i18n,"info_no_changing_information"));
                    this.showEditPermitIpAddress = false
                    return;
                }
            }
            let param = {requestType: inputParam.requestType, permitType: inputParam.permitType, forcedChange: inputParam.forcedChange}
            if (inputParam.addIpAddressList.length > 0) {
                param.addIpAddressList = inputParam.addIpAddressList;
            }
            if (inputParam.modifyIpAddressList.length > 0) {
                param.modifyIpAddressList = inputParam.modifyIpAddressList;
            }
            if (inputParam.removeIpAddressList.length > 0) {
                param.removeIpAddressList = inputParam.removeIpAddressList;
            }
            server.post('/modifypermitipaddresslist', param )
                .then((res) => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            this.showEditPermitIpAddress = false
                            commonUtil.notifyMessage(self,"Success",commonUtil.getMessageText(self.$i18n,"info_permit_ip_address_modified"));
                            if (self.enablePermitIpOption) {
                                if (inputParam.permitType == 0) {
                                    self.$emit('reLoadTenantInfo');
                                }
                            } else {
                                if (inputParam.permitType == 1) {
                                    self.$emit('reLoadTenantInfo');
                                }
                            }
                            self.getPermitIpAddressList();
                            break;
                        case constants.STATUS_ERROR_DENIED:
                            commonUtil.notifyMessage(self,"Warning",commonUtil.getMessageText(self.$i18n,"error_cannot_change_permit_ip"));
                            break;
                        case constants.STATUS_ERROR_NOT_FOUND:
                            // browser's ip address has not included permit ip list.
                            self.$refs.editPermitIpAddress.confirmSaveProcess();
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","modifyPermitIpAddressList").replace("{code}",res.data.status));
                            break;
                    }
                })
                .catch( function ( error ) {
                    commonUtil.putExceptionErrorMessage(self, "modifyPermitIpAddressList", error);
                });
        },
    },
    components: {
        EditPermitIpAddress
    },
    mounted: function() {
    },
    created: function() {
        this.getPermitIpAddressList();
        if (((this.appData.tenantOption >> 2) & 1) == 1) {
            this.enablePermitIpOption = true;
        }
    },
    watch: {
        'appData.tenantOption'(newVal) {
            if (((newVal >> 2) & 1) == 1) {
                this.enablePermitIpOption = true;
            } else {
                this.enablePermitIpOption = false;
            }
        }
    },
    props: [ 'appData' ]
}

</script scoped>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ip-address-record {
    color: #848991;
    border-bottom:1px #eee solid;
    display: block;
}

.object-value {
    padding: 10px 10px;
}

.object-title {
    padding: 10px 10px;
    font-size: 12px;
}

.header-value {
    padding-top: 10px;
    padding-bottom: 10px;
    color: #848991;
    font-size: 12px;
}

.title-box-right {
    position: relative;
    text-align: right;
    vertical-align: middle;
    font-size: 12px;
    float: right;
}

.title-box-left {
    padding: 10px;
    padding-left: 20px;
    color: #848991;
    font-size: 12px;
    vertical-align: middle;
}

</style>
